import React from 'react';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { Spinner } from 'components/UI';
import { DailyPoint } from '../../data/mockData';
import styles from './DailyClientsBarChart.module.scss';

interface DailyClientsBarChartProps {
    daily: Array<DailyPoint>;
    loading: boolean;
}

export const DailyClientsBarChart: React.FC<DailyClientsBarChartProps> = props => {
    if (props.loading) {
        return (
            <div className={styles.loadingWrap}>
                <Spinner />
            </div>
        );
    }

    return (
        <ResponsiveContainer
            width="100%"
            height={220}
        >
            <BarChart
                data={props.daily}
                margin={{ top: 8, right: 8, bottom: 0, left: 0 }}
            >
                <CartesianGrid
                    vertical={false}
                    stroke="#F1F1F1"
                />
                <XAxis
                    dataKey="date"
                    tick={{ fontSize: 11, fontFamily: 'Poppins' }}
                    axisLine={false}
                    tickLine={false}
                    interval={4}
                />
                <YAxis
                    allowDecimals={false}
                    tick={{ fontSize: 11, fontFamily: 'Poppins' }}
                    axisLine={false}
                    tickLine={false}
                />
                <Tooltip
                    cursor={{ fill: '#FAFAFA' }}
                    formatter={(value: number) => [`${value}`, 'New clients']}
                    contentStyle={{ fontFamily: 'Poppins', fontSize: 12, borderRadius: 8 }}
                />
                <Bar
                    dataKey="newClients"
                    fill="#EAB464"
                    radius={[4, 4, 0, 0]}
                    barSize={10}
                />
            </BarChart>
        </ResponsiveContainer>
    );
};

export default DailyClientsBarChart;
